var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 3000",
    enableBackground: "new 0 0 3000 3000",
    xmlSpace: "preserve",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    transform: "scale(1.75 1.75) translate(-700 -700)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#303E7A",
    points: "2169.5,1103.9 2147.6,1345.9 2066.3,1385.2 2090.4,1130.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#303E7A",
    points: "2142.9,1397.2 2121.9,1629.6 2038.3,1680.7 2061.3,1438.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BA0B16",
    points: "2141.2,1080.1 2062.5,1102.3 1834.1,1066.7 1934.8,1040.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#303E7A",
    points: "2116.3,1691.3 2096.9,1904.8 2011.3,1965.7 2032.6,1741.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#303E7A",
    points: "2063.1,1140.3 2038.6,1398.6 1942,1445.3 1967.1,1173.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#303E7A",
    points: "2033.5,1452.3 2010.3,1697.9 1913.3,1757.3 1936.9,1501  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BA0B16",
    points: "2030.3,1111.4 1931.1,1139.4 1709.9,1098.6 1806.8,1073.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#303E7A",
    points: "1907.9,1815.7 2004.6,1758 1983,1985.8 1885.9,2055  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#303E7A",
    points: "1941,1182 1916.2,1457.8 1801.8,1513.2 1823.3,1222.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#303E7A",
    points: "1911.1,1514 1887.8,1772.9 1777.6,1840.4 1797.5,1571.3  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA0B16",
    d: "M1827.2,1168.8l-37.2,10.5l-256.1-37.8c-20.6-3-39.4,12.3-40.6,33.1c-0.2,2.8-0.3,5.8-0.5,8.9 c-1,17.5-2.2,38.4-3.5,60.4l-196.8-34.6l120.7-147l228,30.2l-22.5,29.5l57.2-14.7l230.9,39L1827.2,1168.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#303E7A",
    points: "1882.6,1830.8 1860.9,2072.8 1754.8,2148.3 1773.4,1895.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BA0B16",
    points: "1776.3,915.6 1670.6,1053.9 1448,1019.8 1560,883.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F3F302",
    points: "1773.2,1227.6 1752.1,1512.6 1496.4,1471.5 1510.8,1186.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F3F302",
    points: "1745.9,1597.3 1728,1839.3 1480.2,1793.7 1493.3,1532.6 1747.4,1576.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F3F302",
    points: "1721.5,1927 1704.7,2153.7 1464.5,2103.8 1476.9,1858.7 1681,1899.5 1722.9,1907.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BA0B16",
    points: "1485.6,1287.2 1366.5,1457.6 1129.5,1407.8 1262.6,1245.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F302",
    d: "M1293.8,2027.9l-24.3-77.9l179.9,39.3l-7,105.9c-0.1,1.4-0.1,2.8-0.1,4.2c0.5,14.4,8.5,27.2,20.6,34.2 l-0.4,7.8l-144.5-35.9L1293.8,2027.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F302",
    d: "M1447.4,1853.5l8.8,32.9l-3.6,54.5L1253,1897l-54.6-174.8c57,11.5,192.6,38.9,226.3,45.8L1447.4,1853.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F3F302",
    points: "1358.8,1520 1410.8,1715.8 1182.9,1672.8 1119.7,1470.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BA0B16",
    points: "1389.3,877.7 1301.4,1072.3 1079.4,1053.9 1172.6,856.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F3F302",
    points: "1257.3,1952.2 1281.6,2026.5 1175.2,2014.6 1094.1,1924.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BA0B16",
    points: "1274.5,1131.8 1208.5,1277.9 1152.6,1349.3 952.4,1322.8 1052.9,1110.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F3F302",
    points: "1250.4,1931.4 1250.8,1932.5 1068.2,1895.7 976.9,1794.1 1168.7,1831.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F3F302",
    points: "1049.8,1685.1 1144.2,1801 952,1766.4 844.8,1647.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA0B16",
    d: "M1111,1402.5l-10.4,13.2c-8.3,10.6-11,24.6-7.3,37.5l14,48.7l-64.8,143.5l-221.4-44.9l105.5-223.4 L1111,1402.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ba4349ff8531e198383aed92e04e9ab7.svg";
export { ForwardRef as ReactComponent };